const DashboardEmbed = ({ onGoTopath  }) => {
  
  const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
    const iframeSrc = isDev? "http://localhost:3000/"+ onGoTopath: `${window.location.origin}/app/`+ onGoTopath;
    return (
    
    
    <iframe
      src={iframeSrc}
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
      }}
      title="App Web Datáfono Crypto"
    />
  );
};

export default DashboardEmbed;